// extracted by mini-css-extract-plugin
export var backgroundImage = "ProjectCard-module--backgroundImage--d3dc6";
export var content = "ProjectCard-module--content--85400";
export var logoImage = "ProjectCard-module--logoImage--0c8d0";
export var projectCard = "ProjectCard-module--projectCard--0d869";
export var stats = "ProjectCard-module--stats--3d193";